<template>
  <div class="threePage">
    <div class="small_headline">项目品类:{{ itemClass }}</div>
    <div class="hint">根据新广告法规定，禁用以下词汇：国家级、最高级、最佳、顶级、极品、第一品牌、原价，请填写时注意</div>
    <template>
      <div class="headline">套餐名称</div>
      <el-input v-model="threePageData.packageName" placeholder="请填写套餐名称" style="width: 240px;" size="small"></el-input>
    </template>

    <template>
      <div class="headline">使用人数</div>
      <div>
        <el-radio v-model="threePageData.useNum" label="1">单人</el-radio>
        <el-radio v-model="threePageData.useNum" label="2">双人</el-radio>
        <el-radio v-model="threePageData.useNum" label="3">3-4人</el-radio>
        <el-radio v-model="threePageData.useNum" label="4">4-5人</el-radio>
        <el-radio v-model="threePageData.useNum" label="5">6-7人</el-radio>
        <el-radio v-model="threePageData.useNum" label="6">自定义（1-1人）</el-radio>
      </div>
    </template>

    <template>
      <div class="headline">套餐选择</div>
      <el-tabs type="border-card">
        <el-tab-pane label="已添加商品">
          <div class="shopList">
            <div class="shopList_header">
              <div class="shopList_header_lft">其他</div>
              <el-select v-model="value" placeholder="请选择" size="small">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="shopList_Cont" v-for="item in 2" :key="item">
              <div class="shopList_Cont_name">精选肥牛卷</div>
              <div class="shopList_Cont_price">
                <span style="color:#FF4E20">￥8</span>/份
              </div>
              <div class="shopList_Cont_num">
                <el-input-number
                  v-model="num"
                  @change="handleChange"
                  :min="1"
                  :max="10"
                  label="描述文字"
                  size="small"
                ></el-input-number>
              </div>
              <div class="shopList_Cont_delete">
                <el-button icon="el-icon-delete" circle></el-button>
              </div>
              <div class="shopList_Cont_sort">
                <div class="sort">
                  <i class="el-icon-caret-top"></i>
                </div>
                <div class="sort">
                  <i class="el-icon-caret-bottom"></i>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="商品库">
          <div class="shopBank">
            <div class="shopBank_header">
              <div class="shopBank_header_lft">
                <el-button type="primary" size="small">新增商品</el-button>
              </div>
            </div>
            <div class="shopBank_Cont" v-for="item in 2" :key="item">
              <div class="shopBank_Cont_name">其他</div>
              <div class="col1">精选肥牛卷</div>
              <div class="col1">
                <span style="color:#FF4E20">￥8</span>
                /份
              </div>
              <div class="col1">
                <el-input-number
                  v-model="num"
                  @change="handleChange"
                  :min="1"
                  :max="10"
                  label="描述文字"
                  size="small"
                ></el-input-number>
              </div>
              <div class="col1">
                <el-button icon="el-icon-delete" circle></el-button>
              </div>
              <div class="col1 shopBank_Cont_sort">
                <div class="sort">
                  <i class="el-icon-caret-top"></i>
                </div>
                <div class="sort">
                  <i class="el-icon-caret-bottom"></i>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>

    <template>
      <div class="headline">团购价</div>
      <el-input v-model="threePageData.groupPrices" placeholder="请填写套餐名称" style="width: 240px;" size="small"></el-input>元
    </template>

    <template>
      <div class="headline">团购首图（最多上传5张）</div>
      <el-upload
        action="https://jsonplaceholder.typicode.com/posts/"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </template>

    <template>
      <div class="headline">资质图</div>
      <div class="hint" style="margin-bottom: 15px;">合作特殊品类项目，如：应季食品（月饼/汤圆/粽子），重点品牌（肯德基、永和豆浆等）、酒水、零食、进口食品，请上传对应的资质证明，详情请查看</div>
      <el-upload
        class="avatar-uploader"
        action="https://jsonplaceholder.typicode.com/posts/"
        :show-file-list="true"
        :on-success="handleAvatarSuccess">
        <img v-if="threePageData.aptitudeUrl" :src="threePageData.aptitudeUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </template>

    <div class="headline">商家介绍（非必填）</div>
    <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="threePageData.shopIntroduce"></el-input>
  </div>
</template>

<script>
export default {
  props: ["itemClass", "threeState"],
  data() {
    return {
      threePageData: {
        packageName: "", // 套餐名称
        useNum: "1", // 使用人数
        groupPrices: "", // 团购价
        homeSwiper: [

        ], // 团购首图
        aptitudeUrl: "", //资质图
        shopIntroduce: "" //商家介绍
      },
      imageUrl: '',
      dialogImageUrl: '',
      dialogVisible: false,
      num: 1,
      value: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      useNum: "1",
      name: "",
      textarea: "",
      tableData: []
    };
  },
  watch: {
    threeState(val) {
      this.$emit("upthreeData", this.threePageData)
    }
  },
  mounted() {
    console.log(this.itemClass);
  },
  methods: {
    handleAvatarSuccess(res, file) {
      // console.log(res);
      this.threePageData.aptitudeUrl = URL.createObjectURL(file.raw)
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChange(value) {
      console.log(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.threePage {
  .headline {
    margin: 25px 0px;
    font-size: 16px;
    font-weight: 600;
  }
  .small_headline {
    font-size: 14px;
    margin: 15px 0;
  }
  .hint {
    color: #f7af45;
    font-size: 12px;
  }
  .scheme_class,
  .newClass {
    margin-top: 15px;
  }
  .tables {
    margin-top: 15px;
    width: 100%;
    border: 1px solid #ebeef5;
  }
  .shopList {
    border: 1px solid rgba(235, 238, 245, 1);
    .shopList_header {
      height: 48px;
      line-height: 48px;
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid rgba(235, 238, 245, 1);
      .shopList_header_lft {
        width: 100px;
        text-align: center;
      }
    }
    .shopList_Cont {
      height: 58px;
      line-height: 58px;
      display: flex;
      flex-direction: row;
      text-align: center;
      border-bottom: 1px solid rgba(235, 238, 245, 1);
      .shopList_Cont_name {
        width: 100px;
      }
      .shopList_Cont_price,
      .shopList_Cont_num,
      .shopList_Cont_delete {
        flex: 1;
      }
      .shopList_Cont_sort {
        font-size: 20px;
        line-height: 29px;
        flex: 1;
        display: flex;
        flex-direction: column;
        .sort {
          height: 50%;
        }
      }
    }
  }
  .shopBank {
    border: 1px solid rgba(235, 238, 245, 1);
    .shopBank_header {
      height: 48px;
      line-height: 48px;
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid rgba(235, 238, 245, 1);
      .shopBank_header_lft {
        width: 100px;
        text-align: center;
      }
    }
    .shopBank_Cont {
      height: 58px;
      line-height: 58px;
      display: flex;
      flex-direction: row;
      text-align: center;
      border-bottom: 1px solid rgba(235, 238, 245, 1);
      .shopBank_Cont_name {
        width: 100px;
      }
      .col1 {
        flex: 1;
      }
      .shopBank_Cont_sort {
        font-size: 20px;
        line-height: 29px;
        display: flex;
        flex-direction: column;
        .sort {
          height: 50%;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.threePage {
  .cell {
    text-align: center;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
